import * as React from 'react'
import * as Editable from '../../../Data/Editable'
import {InvoiceTab} from './InvoiceState'
import {InvoiceSubAction} from './InvoiceActions'
import RaisedButton from 'material-ui/RaisedButton'
import {EditableFloatingActionButtons} from '../../../View/EditableFloatingActionButtons'
import Card from 'material-ui/Card/Card'
import ImagePictureAsPdf from 'material-ui/svg-icons/image/picture-as-pdf'
import FlatButton from 'material-ui/FlatButton'
import injectSheet from 'react-jss'
import {card, tabs} from '../../../Style'
import {EditableTextField} from '../../../View/EditableTextField'

const styles = {
    ...tabs,
    ...card
}

interface Props {
    active: boolean,
    state: InvoiceTab
    dispatch: (action: InvoiceSubAction) => void,
}

export const InvoiceTabView =
    injectSheet<Props>(styles)(
        ({classes, state, dispatch, active}) => {
            const
                {invoiceAddressForm} = state,
                disabled = Editable.inputsDisabled(invoiceAddressForm),
                invoiceAddress =
                    Editable.withDefault(
                        state.invoiceAddress,
                        invoiceAddressForm)
            return (
                <div className={classes.tabContent}>
                    {active &&
                    <EditableFloatingActionButtons
                        editable={invoiceAddressForm}
                        onEdit={() => dispatch({
                            type: 'EditInvoice',
                        })}
                        onSave={() => dispatch({
                            type: 'SaveInvoice',
                        })}
                        onDiscard={() => dispatch({
                            type: 'DiscardInvoice',
                        })}
                    />}
                    <form className={classes.tabForm}>
                        <Card
                            className={classes.card}
                        >
                            <div className={classes.cardHeader}>
                                Rechnungsanschrift
                            </div>
                            <div className={classes.cardContent}>
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Name 1"
                                    locked={disabled}
                                    value={invoiceAddress.invoiceName1}
                                    onChange={event => dispatch({
                                        type: 'InvoiceName1Changed',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Name 2"
                                    locked={disabled}
                                    value={invoiceAddress.invoiceName2}
                                    onChange={event => dispatch({
                                        type: 'InvoiceName2Changed',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Name 3"
                                    locked={disabled}
                                    value={invoiceAddress.invoiceName3}
                                    onChange={event => dispatch({
                                        type: 'InvoiceName3Changed',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Name 4"
                                    locked={disabled}
                                    value={invoiceAddress.invoiceName4}
                                    onChange={event => dispatch({
                                        type: 'InvoiceName4Changed',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Straße"
                                    locked={disabled}
                                    value={invoiceAddress.invoiceStreet}
                                    onChange={event => dispatch({
                                        type: 'InvoiceStreetChanged',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Hausnummer"
                                    locked={disabled}
                                    value={invoiceAddress.invoiceHouseNumber}
                                    onChange={event => dispatch({
                                        type: 'InvoiceHouseNumberChanged',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Postleitzahl"
                                    locked={disabled}
                                    value={invoiceAddress.invoiceZipCode}
                                    onChange={event => dispatch({
                                        type: 'InvoiceZipCodeChanged',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Stadt"
                                    locked={disabled}
                                    value={invoiceAddress.invoiceCity}
                                    onChange={event => dispatch({
                                        type: 'InvoiceCityChanged',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Land"
                                    locked={disabled}
                                    value={invoiceAddress.invoiceCountry}
                                    onChange={event => dispatch({
                                        type: 'InvoiceCountryChanged',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Bezahlt markiert"
                                    locked={true}
                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Bezahlt markiert (Datum)"
                                    locked={true}
                                    value="21.05.2107"
                                />
                            </div>
                            <div className={classes.cardFooter}>
                                <FlatButton
                                    icon={<ImagePictureAsPdf/>}
                                    label="Rechnung"
                                    style={{
                                        marginRight: '10px',
                                        marginBottom: '10px'
                                    }}
                                    className="tab__form-footer-button"
                                />
                                <RaisedButton
                                    label="Neu generieren"
                                    primary={true}
                                    style={{
                                        marginRight: '10px',
                                        marginBottom: '10px'
                                    }}
                                />
                                <RaisedButton
                                    label="Gutschrift erstellen"
                                    primary={true}
                                />
                            </div>
                        </Card>
                    </form>
                    <form className={classes.tabForm}>
                        <Card className={classes.card}>
                            <div className={classes.cardHeader}>
                                Rechnungsempfänger
                            </div>
                            <div className={classes.cardContent}>
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="26.06.2017 09:50"
                                    locked={true}
                                    value="max.mustermann@mail.net"
                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="26.06.2017 09:59"
                                    locked={true}
                                    value="helga.habermann@email.de"
                                />
                            </div>
                        </Card>
                    </form>
                </div>
            )
        }
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderDetails/Invoice/InvoiceView.tsx